module.exports = __webpack_public_path__ + "img/ai-agent-2.a71500ba.svg";